import seasonConfig from "./season.json";

const season = seasonConfig.seasons[String(seasonConfig.currentYear)];

if (!season) {
  throw new Error(
    `No season config for ${seasonConfig.currentYear}. Add seasons.${seasonConfig.currentYear} in season.json.`
  );
}

if (typeof season.leagueId !== "string" || !/^\d+$/.test(season.leagueId)) {
  throw new Error(
    "season.json leagueId must be a digit string so JavaScript does not round it."
  );
}

export const currYear = seasonConfig.currentYear;
export const leagueId = season.leagueId;
export const leagueSize = season.leagueSize;
export const week1StartUnixMs = season.week1StartUnixMs;

export const waitingOnDraftMessage = `The ${currYear} draft hasn't happened yet — check back after the draft.`;
export const keepersNotPostedMessage =
  "This year's keeper list isn't posted yet. Check back after the draft.";
